<template>
    <div class="col-12">
        <!-- <draggable
            tag="div"
            class="row"
            :list="form.attcImg"
            v-bind="dragActions"
            @start="isDragging(true)"
            @end="isDragging(false)"
            handle=".moveItem"
            group="sections"
            @change="moveSection"
        >
            <template v-for="(i, idx) in form.attcImg" >
                <div class="row" :key="idx">{{ i }}</div>
            </template>
        </draggable> -->
        <div class="row">
            <div class="col-md-4">
                <div class="input-group mb-3" :style="addImg.image_name ? 'display:none' : ''">
                    <input type="file" class="form-control" id="addImg" ref="inputAddImg" @change="subirImg" accept="image/*" />
                    <label class="input-group-text" for="addImg">Upload</label>
                </div>
                <div class="d-grid gap-2" :style="!addImg.image_name ? 'display:none' : ''">
                    <button class="btn btn-danger" type="button" style="width: 100%;" @click="imageDeleted"><i class="fas fa-trash-alt"></i> Remove</button>
                </div>
                <div class="bd-example">
                    <div v-show="showLoading" class="loadingImg">
                        <Loader></Loader>
                    </div>
                    <img :src="addImg.image ? addImg.image : imgDefault" class="img-fluid previewImage" alt="Responsive image" @click="openFileDialog()" />
                </div>
            </div>
            <div class="col-md-8 isAttachImg">
                <div v-if="addImg.image==null" @click="requireImg()" class="requireImg"></div>
                <div class="row">
                    <div class="col-12">
                        <div class="row form-inline"  style="height: 58px;justify-content: space-between;">
                            <div class="custom-control custom-checkbox my-1 mr-sm-2" style="margin-left: 10px;">
                                <input type="checkbox" class="custom-control-input" id="checkImg" v-model="addImg.isDescription" @change="setUpdate" />
                                <label class="custom-control-label" for="checkImg" >Show Description?</label>
                            </div>
                            <div class="btn-group btn-group-sm" role="group" aria-label="align" style="align-items: center;">
                                <span style="margin-left: 50px; margin-right: 10px;">Content position: </span>
                                <button type="button" :disabled="!addImg.isDescription" :class="['btn btn-outline-dark', addImg.align == 'right' ? 'active' : '']" @click="changeAlign('right')">Right</button>
                                <button type="button" :disabled="!addImg.isDescription" :class="['btn btn-outline-dark', addImg.align == 'below' ? 'active' : '']" @click="changeAlign('below')">Below</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <textarea
                            class="form-control descripImg"
                            placeholder="Description about the image"
                            :disabled="!addImg.isDescription"
                            v-model="addImg.description"
                            @change="setUpdate"
                        ></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import draggable from 'vuedraggable';
import Loader from '@/core/components/shared/Loader';
export default {
    components: {
        Loader,
        // draggable,
    },
    name: 'attachImg',
    props: {
        propForm: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            form: this.propForm,
            imgDefault: window.urlmaster + 'images/no-image.png',
            addImg: {
                image: null,
                rooPath: null,
                image_name: null,
                isDescription: false,
                description: '',
                align: 'below',
            },
            showLoading: false,
        };
    },
    computed: {
        dragActions() {
            return {
                animation: 200,
                group: "sections",
                disabled: false,
                ghostClass: "ghost",
            };
        },
    },
    mounted() {
        this.showAttchImg();
    },
    methods: {
        changeAlign(align) {
            this.addImg.align = align;
            this.setUpdate();
        },
        showAttchImg() {
            let t = this;
            if(t.form.attcImg.length > 0){
                let item = t.form.attcImg[0];
                t.addImg.rooPath = item.rooPath;
                t.addImg.image = window.urlmaster + item.rooPath + item.image_name;
                t.addImg.image_name = item.image_name;
                t.addImg.isDescription = item.isDescription;
                t.addImg.description = item.description;
                t.addImg.align = item.align;
            }
        },
        openFileDialog() {
            let t = this;
            t.$refs.inputAddImg.click();
        },
        requireImg() {
            let t = this;
            t.$swal({
                title: "It is necessary to attach an image.",
                text: "Do you want to upload an image?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes",
                cancelButtonText: "Cancel",
            }).then((result) => {
                if (result.value) {
                    t.openFileDialog();
                }
            });
        },
        setUpdate() {
            this.form.attcImg[0].image_name = this.addImg.image_name;
            this.form.attcImg[0].isDescription = this.addImg.isDescription;
            this.form.attcImg[0].description = this.addImg.description;
            this.form.attcImg[0].align = this.addImg.align;
            this.$emit('updateAttachImg', {
                'isAttacImg': this.form.isAttacImg,
                'attcImg': this.form.attcImg,
            });
        },
        includeAttachImg() {
            this.form.isAttacImg = !this.form.isAttacImg;
            this.setUpdate();
        },
        subirImg(event) {
            let t = this;
            const file = event.target.files[0];
            if (file) {
                const url = URL.createObjectURL(file);
                this.addImg.image = url;
                this.showLoading = true;
                var setImage = new FormData();
                setImage.append("user_id", window.master_client);
                setImage.append("org_id", window.localorgdata);
                setImage.append("folder", 'attachImg');
                setImage.append("img1", file, file.name);
                setImage.append("nombreIMG", "img");
                setImage.append("attachImg_id", new Date().getTime().toString());
                setImage.append("contIMG", 1);
                setImage.append("delIMG", "imgOld");
                setImage.append("contDel", 0);
                window.masterGetBilling
                .post("subirIMG", setImage)
                .then(result => {
                    let urlImg = t.imgDefault; // imagen x defaul
                    if(result.data.imgs["1"]){
                        urlImg = window.urlmaster + result.data.rooPath.slice(1) + result.data.imgs["1"];
                        this.addImg.image_name = result.data.imgs["1"];
                        // Espera un momento para que se vea la imagen
                        setTimeout(() => {
                            this.form.attcImg = [{
                                image_name: this.addImg.image_name,
                                rooPath: result.data.rooPath.slice(1),
                                isDescription: this.addImg.isDescription,
                                description: this.addImg.description,
                                align: this.addImg.align,
                            }];
                            this.setUpdate();
                        }, 10);
                    }else{
                        t.$notify({
                            group: "noti",
                            type: "error",
                            title: "Error:",
                            text: "Image upload failed, please try again.",
                        });
                    }
                    this.showLoading = false;
                })
                .catch(err => {
                    this.showLoading = false;
                    console.log(err);
                });
            }
        },
        imageDeleted () {
            let t = this;
            
            t.$swal({
                title: "Remove the image and its related data.",
                text: "You are sure?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, remove it!",
                cancelButtonText: "Cancel",
            }).then((result) => {
                if (result.value) {
                    this.showLoading = true;
                    var setImage = new FormData();
                    setImage.append("user_id", window.master_client);
                    setImage.append("org_id", window.localorgdata);
                    setImage.append("folder", 'attachImg');
                    setImage.append("image", t.addImg.image_name);
                    window.masterGetBilling
                    .post("delOnlyIMG", setImage)
                    .then(result => {
                        t.addImg.image = t.imgDefault; // imagen x defaul;
                        if(!result.data.status){
                            t.addImg.image_name = null;
                            t.addImg.rooPath = null;
                            t.addImg.isDescription = false;
                            t.addImg.description = '';
                            t.addImg.align = 'below';
                            console.log('delOnlyIMG', result.data)
                            setTimeout(() => {
                                this.form.attcImg =[{
                                    image_name: t.addImg.image_name,
                                    rooPath: t.addImg.rooPath,
                                    isDescription: t.addImg.isDescription,
                                    description: t.addImg.description,
                                    align: t.addImg.align,
                                }];
                                this.setUpdate();
                            }, 10);
                        }else{
                            t.$notify({
                                group: "noti",
                                type: "error",
                                title: "Error:",
                                text: "Image upload failed, please try again.",
                            });
                        }
                        this.showLoading = false;
                    })
                    .catch(err => {
                        this.showLoading = false;
                        console.log(err);
                    });
                }
            });
        },
        isDragging(t) {
            console.log('move', t) // t = true or false
            return t;
        },
        log: function (evt) {
            console.log('log', evt)
        },
        addItem: function (evt) {
            console.log('addItem', evt);
        },
        moveSection(){
            let t = this;
            // let list = [];
            // t.f.actions.forEach((element, idx) => {
            //     list.push(element);
            //     list[idx].item_order = idx;
            // });
            // console.log('moveSection', list)
            // t.f.actions = list;
            // let url = 'orderActionsTaskKnow';
			// window.billing
            // .put(url, t.f)
            // .then((response) => {
            //     console.log(url, response.data);
            // })
            // .catch((error) => {
            //     console.log(error);
			// 	t.isLoading=false;
            // });
        },
    },
};
</script>
<style scoped>
.bd-example {
    position: relative;
    padding: 0.3rem;
    margin: 1rem -.75rem 0;
    border: solid #dee2e6;
    border-width: 1px 0 0
}
@media (min-width: 576px) {
    .bd-example {
        padding: 0.5rem;
        margin-right: 0;
        margin-left: 0;
        border-width: 1px;
        border-top-left-radius: .25rem;
        border-top-right-radius: .25rem
    }
}
img.img-fluid.previewImage:hover {cursor: pointer;}
img.img-fluid.previewImage {
    width: 100%;
    height: 100%;
    min-height: 200px;
    max-height: 200px;
    object-fit: cover;
}
.bd-example {
    text-align: center;
    position: relative;
}
.descripImg{
    height: 220px;
    resize: none;
}
.isAttachImg {position: relative;}
.requireImg {position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(255, 255, 255, 0.5); z-index: 1; cursor: pointer;}
.loadingImg {position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(255, 255, 255, 0.5); z-index: 1; cursor: pointer;}
</style>
